<template>
  <q-inner-loading :showing="showing">
    <q-spinner
      :size="size"
      color="primary"
    />
  </q-inner-loading>
</template>

<script setup>
defineProps({
  showing: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: '50px',
  },
});
</script>
